export const checkTabPermission = (permission = [], groupInfo, userInfo) => {
  const { isInternal, isClient, email } = userInfo;
  const hasGroupPermission = permission.some((key) => {
    const targetGroup = groupInfo?.find((groupItem) => groupItem.id === key);
    if (targetGroup?.groupMembers?.length) {
      return targetGroup?.groupMembers.find(
        (member) =>
          (isClient &&
            member.type === 'Client' &&
            email === member.client.email) ||
          (isInternal &&
            member.type === 'Integration' &&
            email === member.people.email),
      );
    }
    return false;
  });
  return (
    (permission?.includes('client') && isClient) ||
    (permission?.includes('internal') && isInternal) ||
    hasGroupPermission
  );
};
